import React from 'react'
import styles from './RatioImage.module.scss'


export interface RatioImageProps {
  src?: string
  src2x?: string
  style?: React.CSSProperties
  ratio: [number, number]
}

export default function RatioImage({src, src2x, ratio, style}: RatioImageProps) {
  const [w, h] = ratio
  const url = window.devicePixelRatio > 1 ? src2x : src
  return (
    <div
      className={styles.RatioImage}
      style={{
        backgroundImage: url ? `url(${url})` : 'rgba(0, 0, 0, 0.3)',
        paddingTop: `${h / w * 100}%`,
        ...style,
      }}
    />
  )
}
